import { createEmitter } from "../utils/tiny-emitter.js";
/**

 * @internal
 */
export function createWalletEmitter() {
    return createEmitter();
}
//# sourceMappingURL=wallet-emitter.js.map